function flasNewsMng() {
  var actualFlashNewsCookieSaved = Cookies.get('flashNews');
  var flashNewsHtml = jQuery('.header__flashNews--wrapper > div').html();

  if (actualFlashNewsCookieSaved != flashNewsHtml) {

    jQuery('.header__flashNews--wrapper').css('display', 'flex');
  }

  jQuery('.header__flashNews--closeWrapper').on('click', function() {
    Cookies.set('flashNews', flashNewsHtml);
    jQuery('.header__flashNews--wrapper').css('display', 'none');
    headerHeightMng();
  });
}

function mobileMenuMng() {
  jQuery('.header__mobileMenuIcon--wrapper').on('click', function() {
    jQuery('body').toggleClass('mobileMenuOpen');
  });
};

function hpPromoMng() {
  var promo1 = jQuery('.hp__promo--row > .hp__promo--wrapper:nth-child(1)');
  var promo2 = jQuery('.hp__promo--row > .hp__promo--wrapper:nth-child(2)');
  var promo3 = jQuery('.hp__promo--row > .hp__promo--wrapper:nth-child(3)');

  promo1.on('mouseenter', function() {
    jQuery('.hp__promo--row').addClass('promo1');
  });

  promo1.on('mouseleave', function() {
    jQuery('.hp__promo--row').removeClass('promo1');
  });

  promo2.on('mouseenter', function() {
    jQuery('.hp__promo--row').addClass('promo2');
  });

  promo2.on('mouseleave', function() {
    jQuery('.hp__promo--row').removeClass('promo2');
  });

  promo3.on('mouseenter', function() {
    jQuery('.hp__promo--row').addClass('promo3');
  });

  promo3.on('mouseleave', function() {
    jQuery('.hp__promo--row').removeClass('promo3');
  });
};

function headerHeightMng() {
  var headerHeight = jQuery('.mainHeader').height();
  jQuery('body > .container-fluid').css('padding-top', headerHeight);
}

function bodyIDmng() {
  jQuery('body').attr('id', 'w__body');
}

function homeMatchHeight() {
  if (jQuery('.hp__promo--imgWrapper').length > 0) {
    jQuery('.hp__promo--imgWrapper').matchHeight();
  }

  if (jQuery('.hp__promo--body').length > 0) {
    jQuery('.hp__promo--body').matchHeight();
  }
  if (jQuery('.blog__singlePost--infoWrapper').length > 0) {
    jQuery('.blog__singlePost--infoWrapper').matchHeight();
  }

  // var cardHeight = jQuery('.hp__promo--wrapper').height();
  // jQuery('.hp__park--section').css('padding-top', cardHeight - 130);
};

// function postWidth() {
//   if (jQuery('.blog__singlePost--thumb').length > 0) {
//     jQuery('.blog__singlePost--thumb').each(function(){
//       var postThumbWidth  = jQuery(this).width();
//       jQuery(this).height(postThumbWidth / 1.48);
//       console.log('image height set ' + (postThumbWidth / 1.48));
//     });
//   }
// };

/* CUSTOM JSBT */
jQuery(function() {
	var setWindowBootstrapDevice = function() {
		var lg = 1200,
		md = 992,
		sm = 768;

		if (jQuery(window).width() >= lg) {
			window.bootstrapDevice = 'lg';
		} else if (jQuery(window).width() < lg && jQuery(window).width() >= md) {
			window.bootstrapDevice = 'md';
		} else if (jQuery(window).width() < md && jQuery(window).width() >= sm) {
			window.bootstrapDevice = 'sm';
		} else {
			window.bootstrapDevice = 'xs';
		}
	};
	jQuery(window).resize(function() {
		setWindowBootstrapDevice();

    headerHeightMng();

    if (jQuery(window).width() <= 1100) {
      hpPostPaddingBottomMng();
    }

    homeMatchHeight();

    // postWidth();
	});
	setWindowBootstrapDevice();



	//jQuery('.home #myCarousel .carousel-inner').css('height', window.innerHeight);
	// jQuery(window).on('resize', function() {
	// 	jQuery('.home #myCarousel .carousel-inner .item>div:nth-child(1)').css('height', window.innerHeight);
	// 	jQuery('.home #myCarousel .carousel-inner').css('height', window.innerHeight);
	// });


	// jQuery(window).on('scroll', function() {
	// 	if (jQuery(window).scrollTop() >= window.innerHeight) {
	// 		jQuery('#primary-navbar').addClass('red');
	// 		jQuery('.home #logo_aqualandvasto img').attr("src", '/app/themes/sage_new_custom/dist/images/logo_aqualandvasto.png');
	// 	} else {
	// 		jQuery('#primary-navbar').removeClass('red');
	// 		jQuery('.home #logo_aqualandvasto img').attr("src", '/app/themes/sage_new_custom/dist/images/logo_aqualandvasto_red.png');
	// 	}
	// });
});





function blogArchivePaginationMng() {
  // add anchor link to article pagination
  jQuery('.blog__desktopCategoryFiltering > a').each(function(){

    var anchorLink = jQuery(this).attr('href');

    jQuery(this).attr('href', anchorLink + '#category_articles');
  });
}

function headerMng() {

  jQuery('#menu-item-1926 a').html('');
};

function hpPostPaddingBottomMng() {
  if (jQuery('.singlePost__articlesCarousel').length > 0) {
    var hpPostsNumbersHeight = jQuery('.singlePost__articlesCarousel .slick-dots').height();
    jQuery('.hp__posts--section').css('padding-bottom' , hpPostsNumbersHeight + 170);
  }
};


jQuery(document).ready(function(){

  jQuery('.blog__allArticles--categoriesWrapper > a').each(function() {
    var link = jQuery(this).prop('href') + '#category_articles';
    jQuery(this).prop('href', link);
  });

  jQuery('.blog__posts--wrapper .blog__singlePost--wrapper .blog__singlePost--categoryWrapper .categoryElmt__wrapper a').each(function(){
    var link = jQuery(this).prop('href') + '#category_articles';
    jQuery(this).prop('href', link);
  });

  jQuery('.blog__evidencePost__textContent .categoryElmt'). each(function() {
    var link = jQuery(this).prop('href') + '#category_articles';
    jQuery(this).prop('href', link);
  });

  jQuery('.blog__singlePost--categoryWrapper .categoryElmt__wrapper .categoryElmt'). each(function() {
    var link = jQuery(this).prop('href') + '#category_articles';
    jQuery(this).prop('href', link);
  });

    // home page slider
    if (jQuery('.hp__hero--carousel').lenght > 0) {
      jQuery('.hp__hero--carousel').slick();
    }

    blogArchivePaginationMng();

    headerMng();

    hpPromoMng();

    mobileMenuMng();

    bodyIDmng();

    // flasNewsMng();
});

jQuery(window).load(function(){

  if (jQuery(window).width() <= 1100) {
    hpPostPaddingBottomMng();
  }

  headerHeightMng();

  homeMatchHeight();
  
});

// jQuery(window).on('load', function() {

//   postWidth();

// });
